import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { CreatedMeeting, Meeting } from 'src/app/types';
import { MeetingService } from '../../services/meeting.service';

type AppointmentParams = { pag: number; userId: number };

@Component({
  selector: 'app-new-appointment',
  templateUrl: './new-appointment.component.html',
  styleUrls: ['./new-appointment.component.scss'],
})
export class NewAppointmentComponent implements OnInit {
  @ViewChild('dateInput') dateInput: ElementRef<HTMLInputElement>;
  @ViewChild('timeInput') timeInput: ElementRef<HTMLInputElement>;
  @Input() public user: any;
  public services: any[] = [];
  public operators: any[] = [];
  public min = new Date();
  public createdAppointments: CreatedMeeting[] = [];
  public appointment: Meeting = {
    startHour: '',
    endHour: '',
    duration: '',
    serviceId: '',
    operatorId: '',
    date: '',
    userId: '',
  };
  public totalPages = 1;
  public appointmentParams: AppointmentParams = {} as AppointmentParams;

  constructor(
    private httpSv: HttpService,
    public authSv: LoginService,
    private meetingSv: MeetingService
  ) {}

  async ngOnInit() {
    this.appointmentParams = {
      userId: this.user.id,
      pag: 1,
    };

    this.getAppointmentsByUser();
    this.min.setHours(0, 0, 0, 0);
    const resOp = await this.httpSv.itemIndex(
      'admin/user/index//8/',
      '',
      '',
      ''
    );
    const res: any = await this.httpSv.allServices();
    this.operators = resOp.data;
    this.services = res.data;
  }

  async getAppointmentsByUser() {
    const response = await this.meetingSv.getAppointmentsByUser(
      this.appointmentParams
    );
    this.totalPages = response.data.meta.total;
    this.createdAppointments = response.data.data;
  }

  changePage(newPage: number) {
    this.appointmentParams.pag = newPage;
    this.getAppointmentsByUser();
  }

  calcEndHour(ev?: Event, valueD?: string) {
    const value = ev ? (ev.target as HTMLInputElement).value : valueD;
    this.meetingSv.calcEndHour(this.appointment, value, this.services);
  }

  normalizeDate(ev: Event) {
    const value = (ev.target as HTMLInputElement).value;
    const currentDate = new Date(value);
    this.appointment.date = `${currentDate.getDate() + 1}/${
      currentDate.getMonth() + 1
    }/${currentDate.getFullYear()}`;
    // this.meetingSv.normalizeDate(this.appointment, type, field, ev);
  }

  // normalizeDate(type: 'calendar' | 'timer', field: string, ev) {
  //   this.meetingSv.normalizeDate(this.appointment, type, field, ev);
  // }

  async editAppointment(appointmentId: CreatedMeeting['id']) {
    const appointment = await this.meetingSv.getAppointment(appointmentId);
    this.appointment = {
      date: appointment.data.date,
      duration: appointment.data.duration,
      endHour: appointment.data.endHour,
      id: appointment.data.id,
      operatorId: appointment.data.operatorId,
      serviceId: appointment.data.serviceId,
      startHour: appointment.data.startHour,
      userId: appointment.data.userId,
    };
    this.dateInput.nativeElement.value = this.appointment.date;
    this.timeInput.nativeElement.value = this.appointment.startHour;
  }

  deleteAppointment(appointmentId: CreatedMeeting['id']) {
    this.meetingSv.deleteAppointment(appointmentId);
    this.getAppointmentsByUser();
  }

  async saveAppointment() {
    if (this.authSv?.user?.rolId === 8) {
      this.appointment.operatorId = this.authSv.user.id;
    }

    const response = await this.meetingSv.saveAppointment(
      this.appointment,
      this.user.id
    );
    if (response) {
      this.clear();
      this.dateInput.nativeElement.value = '';
      this.timeInput.nativeElement.value = '';
      this.getAppointmentsByUser();
    }
  }

  clear() {
    this.appointment = {
      id: undefined,
      date: '',
      duration: '',
      endHour: '',
      operatorId: '',
      serviceId: '',
      startHour: '',
      userId: '',
    };
  }
}
